import { ActionTypes } from "../constants";

const reduceTasks = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_TASKS_SUCCESS:
            return action.data || [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceTasks;
